import React, {useEffect, useState} from "react";
import FolderGrid from "../../components/FolderGrid";
import {Route, Routes, useNavigate, useParams} from "react-router-dom";
import {Button, Image, Modal} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faArrowLeft} from "@fortawesome/free-solid-svg-icons";
import {useAuth} from "../../providers/authprovider";
import useAlert from "../../components/CustomAlert";
import Loading from "../../components/LoadingInfo";



function eventTypeNamePl(type){
    switch (type) {
        case 'MALFUNCTION':
            return 'Zgłoszenie/Awaria';
        case 'INSPECTION':
            return 'Inspekcja';
        case 'TRAINING':
            return 'Szkolenie';
        default:
            return '';
    }
}

export default function BuildingImageGallery(props){

    const {buildingId} = useParams();
    const {buildings:{getImageFolders}} = useAuth();
    const navigate = useNavigate();
    const {alert, showAlert} = useAlert();

    const [folders, setFolders] = useState(undefined);

    useEffect(()=>{
        if(folders !== undefined)
            return;

        getImageFolders(buildingId, ({success, error, content})=>{
            if(success)
                return setFolders(content.map(c=>{

                    let d = new Date(c.date);

                    d.toLocaleDateString()

                    return {...c, name:eventTypeNamePl(c.type)+" "+d.toLocaleDateString()}
                }))

            showAlert(error);
            setFolders([]);
        })
    })

    const handleSelect = (folder)=>{
        console.log(folder)
        navigate(`./${folder.event_id}`)
    }

    const navigateBack = ()=>{
        navigate(-1)
    }

    return (
        <Routes>
            <Route path={'/'} element={
                <div className={"container"}>
                    {alert()}
                    <Button variant={"outline-secondary"} className="m-3 me-4 float-start" onClick={navigateBack} ><FontAwesomeIcon icon={faArrowLeft} /> Powrót</Button>

                    <FolderGrid folders={folders} onSelect={handleSelect} />
                </div>
            }/>
            <Route path={'/:eventId'} element={
                <div className={"container"}>
                    <Button variant={"outline-secondary"} className="m-3 me-4 float-start" onClick={navigateBack} ><FontAwesomeIcon icon={faArrowLeft} /> Powrót</Button>

                    <BuildingImages />
                </div>
            }/>
        </Routes>


    )
}

function BuildingImages(props){

    const {eventId} = useParams()
    const {alert, showAlert} = useAlert();
    const [images, setImages] = useState(undefined);
    const {buildings:{getEventImages}} = useAuth();
    const [imageModal, setImageModal] = useState({show:false, url:undefined})

    useEffect(()=>{
        if(images !== undefined) return;

        getEventImages(eventId, ({success,error, content})=>{
            if(success)
                return setImages(content)

            showAlert(error)
            setImages([]);
        } )
    })

    const hideImageModal = ()=>{
        setImageModal({show:false, url:undefined})
    }

    const handleShowImageModal = (url)=>{
        setImageModal({show:true, url:url})
    }

    return (
        <div className={"container d-flex"}>
            {alert()}
            {
                images?.map( image =>{
                    return <EventImage image={image} onClick={handleShowImageModal} />
                })
            }
            <Modal
                show={imageModal.show}
                onHide={hideImageModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <img src={imageModal.url} />
            </Modal>
        </div>
    )
}

function EventImage(props){

    const {image} = props
    const {buildings: {downloadEventImage}, getUrl} = useAuth();
    const [url, setUrl] = useState(undefined)

    useEffect(()=>{
        if(url !== undefined) return;

        downloadEventImage(image.id, ({success, error, content})=>{
            if(!success)
                return;

            setUrl(getUrl(content))
        })
    })


    return (
        <div className={"eventImage"} onClick={()=>props.onClick(url)}>
            {url !== undefined ? <Image src={url} fluid={true} alt={image.filename}/> : <Loading />}
        </div>
    )
}